var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"VideoDemo"}},[_c('div',{staticClass:"container"},[_c('br'),_c('div',{staticClass:"is-relative"},[_c('a',{staticClass:"video-play-button",attrs:{"id":"play-video"},on:{"click":_vm.cardModal}},[_c('span')])]),_c('br'),_c('br'),_c('br')])])
}
var staticRenderFns = []

export { render, staticRenderFns }